import React from "react";
import { X, ZoomIn, ZoomOut, Check, ChevronLeft, ChevronRight } from "lucide-react";

/** Filename, zoom controls and close. */
export const LightboxToolbar = ({ name, zoom, onZoomIn, onZoomOut, onClose }) => (
  <div className="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-[#1E1E1E]">
    <span className="font-mono-accent text-xs text-[#D4AF37] truncate">{name}</span>
    <div className="flex items-center gap-3 sm:gap-4">
      <button data-testid="lightbox-zoom-out" onClick={onZoomOut}
        className="text-[#A8A8A8] hover:text-[#D4AF37]" aria-label="Zoom out">
        <ZoomOut size={18} />
      </button>
      <span className="font-mono-accent text-[10px] text-[#707070]">{zoom.toFixed(1)}×</span>
      <button data-testid="lightbox-zoom-in" onClick={onZoomIn}
        className="text-[#A8A8A8] hover:text-[#D4AF37]" aria-label="Zoom in">
        <ZoomIn size={18} />
      </button>
      <button data-testid="lightbox-close" onClick={onClose} className="text-[#A8A8A8] hover:text-[#F3F3F1]" aria-label="Close">
        <X size={20} />
      </button>
    </div>
  </div>
);

const navClass = "absolute top-1/2 -translate-y-1/2 glass border border-[#2A2A2A] p-3 text-[#F3F3F1] hover:border-[#D4AF37] transition-colors";

/** Previous / next arrows, each rendered only when that direction is available. */
export const LightboxNav = ({ onPrev, onNext }) => (
  <>
    {onPrev && (
      <button data-testid="lightbox-prev" onClick={onPrev} aria-label="Previous photo"
        className={`${navClass} left-3 sm:left-6`}>
        <ChevronLeft size={20} />
      </button>
    )}
    {onNext && (
      <button data-testid="lightbox-next" onClick={onNext} aria-label="Next photo"
        className={`${navClass} right-3 sm:right-6`}>
        <ChevronRight size={20} />
      </button>
    )}
  </>
);

/** The full-screen select / selected toggle. */
export const LightboxSelectButton = ({ selected, label, onClick }) => (
  <button
    data-testid="lightbox-select-btn"
    onClick={onClick}
    aria-pressed={selected}
    className={`absolute bottom-6 left-1/2 -translate-x-1/2 inline-flex items-center gap-2.5 px-6 py-3.5 text-[11px] tracking-[0.18em] uppercase font-semibold border transition-colors duration-300 ${
      selected
        ? "bg-[#D4AF37] text-black border-[#D4AF37]"
        : "glass text-[#F3F3F1] border-[#2A2A2A] hover:border-[#D4AF37]"
    }`}
  >
    <span className={`flex items-center justify-center w-5 h-5 border ${
      selected ? "bg-black/15 border-black/40" : "border-[#707070]"
    }`}>
      {selected && <Check size={13} strokeWidth={3} />}
    </span>
    {label}
  </button>
);
